export default {"src":"/_next/static/media/Widget3.ec4ee76d.svg","height":280,"width":346,"blurWidth":0,"blurHeight":0};